import { render, staticRenderFns } from "./new.vue?vue&type=template&id=f80474a2&scoped=true&lang=html&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"
import style0 from "./new.vue?vue&type=style&index=0&id=f80474a2&scoped=true&lang=css&"
import style1 from "./new.vue?vue&type=style&index=1&lang=css&"
import style2 from "./new.vue?vue&type=style&index=2&id=f80474a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80474a2",
  null
  
)

export default component.exports